// function to filter cookies and get cookie by name
const getCookie = (cname) => {
  let name = cname + '='
  let decodedCookie = decodeURIComponent(document.cookie)
  let ca = decodedCookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

// function to set a cookie
const setCookie = (cname, cvalue, exdays, domain) => {
  const d = new Date()
  const domainAttribute = domain ? `;domain=${domain}` : ''
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  let expires = 'expires=' + d.toUTCString()
  document.cookie = `${cname}=${cvalue};${expires};path=/${domainAttribute}`
}

const userHasAuthCookies =
  getCookie('auth_id_token') && getCookie('auth_refresh_token')
const seamlessLoginRetries = getCookie('seamless-login-retries') || 0
const loginUrl = window.themeSettings.subscriptionUrl
  ? `${window.themeSettings.subscriptionUrl}/auth/login`
  : ''

const currentUrl = window.location.href

// Redirect to login page if user has auth cookies and has not tried to seamless login more than 3 times
if (userHasAuthCookies && parseInt(seamlessLoginRetries) < 3 && loginUrl) {
  setCookie(
    'seamless-login-retries',
    parseInt(seamlessLoginRetries) + 1,
    1,
    window.location.hostname
  )
  document.location.href = `${loginUrl}?market-redirect-to=${currentUrl}`
}
